export default {
    namespaced: true,

    state: {
        refreshSalrOrderList: false
    },

    mutations: {
        SET_ACTION_TO_TRIGGER(state, payload) {
            state.refreshSalrOrderList = payload;
        }
    },

    actions: {
        /**
         * 触发刷新列表
         * @param commit
         */
        triggerRefreshSalrOrderList({commit}) {
            commit('SET_ACTION_TO_TRIGGER', true);
        },
        /**
         * 重置刷新列表
         * @param commit
         */
        resetRefreshSalrOrderList({commit}) {
            commit('SET_ACTION_TO_TRIGGER', false);
        }
    },

    getters: {
        refreshSalrOrderList: state => state.refreshSalrOrderList
    }
};
